import type { FaireProductEntity } from "../../entity_types/product";

export const p_djs150dndu: FaireProductEntity = {
  token: "p_djs150dndu",
  type: "product",
  name: "Toketee Organic Blend, 12 oz",
  brandToken: "b_3angyj4q6y",
  brandName: "Sightglass Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/d90307b703e88f05077baa60a719d202c5279513fecff4011f48c88072bb6ed1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b82b58d129f78ef934797c027142575053e449026c4f9295fb856d7491b635ba.png",
    "https://cdn.faire.com/fastly/e9d71021f2fdb4f03cb227ab97c8d57708fe82d6f307993b8951f4feef8aab94.jpeg",
    "https://cdn.faire.com/fastly/443a70ba743c00b079f7e372b3cc355b79a72c0c0266c0829510f4a5b1cf40d5.jpeg",
    "https://cdn.faire.com/fastly/e136cb9c51e8bf15ed806bbf4ecc8f46f7650e750620a3d644182d77c7023bf9.jpeg"
  ],
  priceDollars: 12.15,
  description: "Toketee is our take on the classic coffee house drip blend, showcasing carefully curated, seasonally rotating coffees from Central and South America.\n\nCCOF Certified Organic\n\nTaste Notes // Apricot, Cacao Nib, Caramel\n\nRoast Profile // Medium-dark\n\nRecommended Brew Methods // French Press, Aeropress, V60, Cold Brew\n\nShelf Life // All our whole bean coffees are roasted fresh to order and stamped with the roast date. We encourage selling the coffee within 90 days of the roast date for optimal freshness and flavor.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:54.869Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
